import Dialog from '~/domains/design-system/components/Dialog/Dialog';
import DialogContainer from '~/domains/design-system/components/Dialog/DialogContainer';
import { Title } from '~/domains/design-system/Title';
import { Text } from '~/domains/design-system/Text';
import { Button, UnstyledButton } from '~/domains/design-system/Button';
import IconX from '~/domains/design-system/icons/IconX';
import useTranslation from 'next-translate/useTranslation';

import useStyles from './DisableChatModal.styles';

interface DisableChatModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  isCurrentlyEnabled: boolean;
}

function DisableChatModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  isCurrentlyEnabled,
}: DisableChatModalProps) {
  const { classes, theme } = useStyles();
  const { t } = useTranslation('chat');

  const title = isCurrentlyEnabled
    ? t('disableChatModal.title.disable')
    : t('disableChatModal.title.enable');
  const description = isCurrentlyEnabled
    ? t('disableChatModal.description.disable')
    : t('disableChatModal.description.enable');
  const confirmButtonText = isCurrentlyEnabled
    ? t('disableChatModal.confirmButtonText.disable')
    : t('disableChatModal.confirmButtonText.enable');
  const loadingText = isCurrentlyEnabled
    ? t('disableChatModal.loadingTextDisable')
    : t('disableChatModal.loadingTextEnable');

  return (
    <DialogContainer isOpen={isOpen} onClose={onClose}>
      <Dialog
        type={{
          desktop: 'modal',
          mobile: 'drawer',
        }}
        isOpen={isOpen}
        onClose={onClose}
        className={classes.dialogWrapper}
      >
        <div className={classes.container}>
          <div className={classes.content}>
            <div className={classes.titleContainer}>
              <Title tag="h2" variant="headline-large" color={theme.colors.gray2[6]}>
                {title}
              </Title>
            </div>

            <div className={classes.descriptionContainer}>
              <Text variant="body-large" color={theme.colors.gray2[4]}>
                {description}
              </Text>
            </div>

            <div className={classes.buttonsContainer}>
              <Button
                variant="secondary-fill"
                size="large"
                onClick={onConfirm}
                disabled={isLoading}
                loading={isLoading}
                fullWidth
              >
                {isLoading ? loadingText : confirmButtonText}
              </Button>

              <Button
                variant="tertiary-fill"
                size="large"
                onClick={onClose}
                disabled={isLoading}
                fullWidth
              >
                {t('disableChatModal.cancelButtonText')}
              </Button>
            </div>
          </div>
        </div>
      </Dialog>
    </DialogContainer>
  );
}

export default DisableChatModal;
